module.exports = __webpack_public_path__ + "img/tr.3fcf224.webp";